import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router"

import { Logo } from "@/components/logo"
import { RouteLoadingMinimal } from "@/components/route-loading"
import { ensureSession } from "@/http/auth/session"

export const Route = createFileRoute("/_guest")({
  loader: async () => {
    const hasSession = await ensureSession()
    if (hasSession) {
      throw redirect({ to: "/home" })
    }
    return null
  },
  component: RouteComponent,
  pendingComponent: RouteLoadingMinimal,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center self-center">
          <Logo size="lg" />
        </Link>
        <Outlet />
      </div>
    </div>
  )
}
